import { useState, useEffect, useCallback } from "react";
import type { NLSDocument, Statement } from "../documents/types.ts";
import { getDocument, updateDocument } from "../documents/store.ts";

export function useDocument(documentId: string | undefined) {
  const [document, setDocument] = useState<NLSDocument | null>(null);

  useEffect(() => {
    if (!documentId) {
      setDocument(null);
      return;
    }
    const doc = getDocument(documentId);
    setDocument(doc ?? null);
  }, [documentId]);

  const save = useCallback(
    (root: Statement) => {
      if (!documentId) return;
      updateDocument(documentId, root);
      // Refresh local state
      const doc = getDocument(documentId);
      if (doc) setDocument({ ...doc });
    },
    [documentId]
  );

  return { document, save };
}
